import Seo from "@/components/site/Seo";
import Hero from "@/components/home/Hero";
import { TrustBar, Destinations } from "@/components/home/Destinations";
import { Services, WhyImmistop } from "@/components/home/Services";
import { Process, Testimonials, InsightsPreview } from "@/components/home/Journey";
import { CTABanner, Marquee } from "@/components/site/Blocks";

export default function Home() {
  return (
    <>
      <Seo description="Private immigration advisory for professionals, investors and families moving to the UK, Australia, New Zealand, Canada, the USA and Europe. Subject to eligibility." />
      <Hero />
      <TrustBar />
      <div className="bg-ivory pt-24"><Marquee items={["London", "Sydney", "Auckland", "Toronto", "New York", "Paris", "Lisbon", "Valletta"]} /></div>
      <Destinations />
      <Services />
      <WhyImmistop />
      <Process />
      <Testimonials />
      <InsightsPreview />
      <CTABanner />
    </>
  );
}
